import { render, staticRenderFns } from "./ChannelTypeIcon.vue?vue&type=template&id=0f4fd8ac&scoped=true&"
import script from "./ChannelTypeIcon.vue?vue&type=script&lang=ts&"
export * from "./ChannelTypeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4fd8ac",
  null
  
)

export default component.exports